import VideoPlayer from '../shared/videoPlayer';
import LockCollateralStatusSignalR from '../shared/lockCollateralStatusSignalR';

const builderForwardVideoGenerationTimeout = 300; //in seconds

$(function () {
    if ($('#builderforward_confirmation_page').length) {
        $(function () {
            var confirmationNumber = $('#hdnConfirmationNumber').val();

            var $loading = $('#ll_loading-div').hide();
            var button = $('#attach-button');
            var input = $('#attach-input');
            var logobutton = $('#logo-attach-button');
            var logoinput = $('#logo-attach-input');
            var form = new FormData();
            form.append("confirmationNumber", confirmationNumber);

            var exist = $("#hdnConfirmExists").val();

            if (exist) {
                if ($("#slopenimg").attr('src') == "") {
                    $.ajax({
                        url: 'generate-promotional-flyer',
                        type: 'POST',
                        cache: false,
                        contentType: false,
                        processData: false,
                        data: form,
                        beforeSend: function () {
                            $("#slopenimg").attr("src", "https://cloud.cmgfi.com/dvbdysuf5/image/upload/CMG_Web_Resources/Shared_Images/ll-loading.gif");
                        },
                        success: function (response) {
                            if (response != "") {
                                response = response.replace("/upload/", "/upload/fl_attachment:PromoFlyer/")
                                $("#slopenlink").attr("href", response);
                                $("#slopenimg").attr("src", response.replace(".pdf", ".png"));
                            }
                        }
                    });
                }

                if ($("#socialpmtopenimg").attr('src') == "") {
                    $.ajax({
                        url: 'generate-builder-socialPMT',
                        type: 'POST',
                        cache: false,
                        contentType: false,
                        processData: false,
                        data: form,
                        beforeSend: function () {
                            $("#socialpmtopenimg").attr("src", "https://cloud.cmgfi.com/dvbdysuf5/image/upload/CMG_Web_Resources/Shared_Images/ll-loading.gif");
                        },
                        success: function (response) {
                            if (response != "") {
                                response = response.replace("/upload/", "/upload/fl_attachment:SocialPostFlyer/")
                                $("#socialpmtopenlink").attr("href", response);
                                $("#socialpmtopenimg").attr("src", response.replace(".pdf", ".png"));
                            }
                        }
                    });
                }

                if ($("#educationpostimg").attr('src') == "") {
                    $.ajax({
                        url: 'generate-featured-rate-post',
                        type: 'POST',
                        cache: false,
                        contentType: false,
                        processData: false,
                        data: form,
                        beforeSend: function () {
                            $("#educationpostimg").attr("src", "https://cloud.cmgfi.com/dvbdysuf5/image/upload/CMG_Web_Resources/Shared_Images/ll-loading.gif");
                        },
                        success: function (response) {
                            if (response != "") {
                                response = response.replace("/upload/", "/upload/fl_attachment:FeaturedRateFlyer/")
                                $("#educationpostlink").attr("href", response);
                                $("#educationpostimg").attr("src", response.replace(".pdf", ".png"));
                            }
                        }
                    });
                }
            }

            $('#new-rate').on('change', function (e) {
                $("#current_rate").removeClass('d-none');

                var currentRate = $("#current_rate").data('rate');
                if (this.value == currentRate)
                    $("#update_featured").addClass('d-none');
                else
                    $("#update_featured").removeClass('d-none');
            });

            function BuildFormData(files) {
                var data = new FormData();
                data.append("confirmationNumber", confirmationNumber);

                for (var i = 0; i < files.length; i++) {
                    data.append(files[i].name, files[i]);
                }

                return data;
            }

            button.on('click', function (e) {
                e.preventDefault();
                input.click();
            });

            logobutton.on('click', function (e) {
                e.preventDefault();
                logoinput.click();
            });

            input.on('change', function (e) {
                var data = BuildFormData(e.target.files);

                var url = window.location.origin + window.location.pathname + '/upload-listing-image';

                $.ajax({
                    type: 'POST',
                    url: url,
                    contentType: false,
                    processData: false,
                    data: data,
                    beforeSend: function () {
                        $("#listing-image-form").addClass("d-none");
                        $("#form-listing-image").addClass("d-none");
                        $("#loading-img-listing").removeClass("d-none");
                        $('#listing_image').prop('src', 'https://cloud.cmgfi.com/dvbdysuf5/image/upload/CMG_Web_Resources/Shared_Images/ll-loading.gif');
                    },
                    success: function (result) {
                        if (result.success) {
                            // FIX: Update listing image IMMEDIATELY with the new URL from server response
                            // This ensures user sees new image before page reload, avoiding cached image display
                            if (result.listingImageUrl && result.listingImageVersion) {
                                var freshImageUrl = result.listingImageUrl;

                                // Ensure _final version (with badge overlay)
                                if (!freshImageUrl.includes('_final')) {
                                    var lastDot = freshImageUrl.lastIndexOf('.');
                                    if (lastDot > 0) {
                                        freshImageUrl = freshImageUrl.substring(0, lastDot) + '_final' + freshImageUrl.substring(lastDot);
                                    }
                                }

                                // Add cache-busting parameter
                                freshImageUrl += '?v=' + result.listingImageVersion;

                                // Update image immediately
                                $('#listing_image').prop('src', freshImageUrl);

                                console.log('[LISTING_IMAGE] Updated immediately to: ' + freshImageUrl);
                            }

                            // Force hard reload to bypass browser cache and ensure fresh flyer thumbnails
                            location.reload(true);
                            return;
                        }

                        console.log(result.error);
                        $("#form-listing-image").removeClass("d-none");
                        $("#listing-image-form").removeClass("d-none");
                        $("#loading-img-listing").addClass("d-none");
                        $('#listing_image').prop('src', $('#listing_image').data('backup-src'))
                    },
                    error: function (XMLHttpRequest, textStatus, errorThrown) {
                        console.log("Status: " + textStatus); alert("Error: " + errorThrown);

                        $('#loading-builderlogo').addClass('d-none');
                    }
                });
            });

            logoinput.on('change', function (e) {
                var data = BuildFormData(e.target.files);

                var url = window.location.origin + window.location.pathname + '/upload-builder-logo';

                $.ajax({
                    type: 'POST',
                    url: url,
                    contentType: false,
                    processData: false,
                    data: data,
                    beforeSend: function () {
                        $('#loading-builderlogo').removeClass('d-none');
                        $("#builder-logo-form").addClass("d-none");
                    },
                    success: function (result) {
                        if (result.success) {
                            // Update builder logo immediately with the new URL from server response
                            // This ensures user sees new image before page reload, avoiding cached image display
                            if (result.builderLogoUrl) {
                                $('#builder_logo').prop('src', result.builderLogoUrl + '?v=' + Date.now());
                                console.log('[BUILDER_LOGO] Updated immediately to: ' + result.builderLogoUrl);
                            }

                            // Force hard reload to bypass browser cache and ensure fresh flyer thumbnails
                            location.reload(true);
                            return;
                        }

                        console.log(result.error);
                        $("#builder-logo-form").removeClass("d-none");
                        $('#loading-builderlogo').addClass('d-none');
                    },
                    error: function (XMLHttpRequest, textStatus, errorThrown) {
                        console.log("Status: " + textStatus); alert("Error: " + errorThrown);

                        $('#loading-builderlogo').addClass('d-none');
                    }
                });
            });

            $('#buttonSendMarketingCollateral').on('click', function (e) {
                e.preventDefault();

                var data = new FormData();
                data.append("confirmationNumber", confirmationNumber);
                data.append("builder-email", $("#builder-email").val());

                $.ajax({
                    url: window.location.origin + window.location.pathname + '/send-marketing-collateral',
                    type: 'POST',
                    cache: false,
                    contentType: false,
                    processData: false,
                    data: data,
                    beforeSend: function () {
                        $loading.show();
                    },
                    success: function (response) {
                        $loading.hide();
                        if (response.success) {
                            alert("Email sent successfully!")
                            return;
                        }
                    }
                });
            });

            $('#new_sales_price').on('focus', function (e) {
                if ($(this).val() === '$0') {
                    $(this).val('');
                }
            });

            $('#new_sales_price').on('keyup change', function (e) {
                $('#update_price_error_message').addClass('d-none');
                $('#no_rates_message').addClass('d-none');

                var filteredValue = $(this).val().replace(/\D/g, '');
                if (!filteredValue) {
                    $(this).val('$0');
                    return;
                }

                var curValue = Number($('#current_sales_price').val().replace(/\D/g, ''));
                var newValue = Number(filteredValue);
                $(this).val(newValue.toLocaleString('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 }));

                if (Math.abs(1 - newValue / curValue) < 0.25) {
                    $('#update_price').prop("disabled", false);
                }
                else
                    console.log('current diff: ' + Math.abs(1 - newValue / curValue));
            });

            $('#new_sales_price').on('blur', function (e) {
                $('#update_price_error_message').addClass('d-none');
                $('#no_rates_message').addClass('d-none');

                var newValue = Number($('#new_sales_price').val().replace(/\D/g, ''));
                if (newValue == 0)
                    return;

                var curValue = Number($('#current_sales_price').val().replace(/\D/g, ''));

                console.log('price diff: ' + Math.abs(1 - newValue / curValue));
                if (Math.abs(1 - newValue / curValue) > 0.25) {
                    $('#price_error_message').removeClass('d-none');
                    $('#update_price').prop("disabled", true);
                }
                else {
                    $('#price_error_message').addClass('d-none');
                    $('#update_price').prop("disabled", false);
                }
            });

            $('#update_price, #revert_original_price').on('click', function (e) {
                $('#price_change_form').parent().addClass('d-none');
                $('#loading-img-price').removeClass('d-none');

                $('#update_price_error_message').addClass('d-none');
                $('#no_rates_message').addClass('d-none');

                var postUrl = $(this).attr('id') == 'update_price'
                    ? `update-price?confirmationNumber=${confirmationNumber}&newPrice=${Number($('#new_sales_price').val().replace(/\D/g, ''))}`
                    : `update-price?confirmationNumber=${confirmationNumber}`;

                $.post(postUrl)
                    .done(function () {
                        location.reload();
                    })
                    .fail(function (jqXHR, textStatus, errorThrown) {
                        $('#update_price_error_message').removeClass('d-none');

                        $('#price_change_form').parent().removeClass('d-none');
                        $('#loading-img-price').addClass('d-none');
                    });
            });

            $('#update_featured').on('click', function (e) {
                e.preventDefault();

                $("#loading-img-featured").removeClass("d-none");
                $('#featured_update_error_message').addClass('d-none');
                $('#featured_rate_form').parent().addClass('d-none');
                var postUrl = $(this).attr('id') == 'update_featured'
                    ? `update-featured?confirmationNumber=${confirmationNumber}&lockrate=${$("#new-rate option:selected").val()}`
                    : `update-featured?confirmationNumber=${confirmationNumber}`;

                $.post(postUrl)
                    .done(function (data, textStatus, jqXHR) {
                        $("#loading-img-featured").addClass("d-none");
                        location.reload();
                    })
                    .fail(function (jqXHR, textStatus, errorThrown) {
                        $('#featured_update_error_message').removeClass('d-none');
                        $('#featured_rate_form').parent().removeClass('d-none');
                        $('#loading-img-featured').addClass('d-none');
                    });
            });

            $('#revert_featured').on('click', function (e) {
                e.preventDefault();

                $("#loading-img-featured").removeClass("d-none");
                $('#featured_update_error_message').addClass('d-none');
                $('#featured_rate_form').parent().addClass('d-none');

                $.post(`revert-featured?confirmationNumber=${confirmationNumber}`)
                    .done(function (data, textStatus, jqXHR) {
                        location.reload();
                    })
                    .fail(function (jqXHR, textStatus, errorThrown) {
                        $('#featured_update_error_message').removeClass('d-none');
                        $('#featured_rate_form').parent().removeClass('d-none');
                        $('#loading-img-featured').addClass('d-none');
                    });
            });

            // Initialize SignalR for video status updates
            var videoStatusHub = null;

            if ($('#property_video').is('.pending') || $('#educational_video').is('.pending')) {
                videoStatusHub = new LockCollateralStatusSignalR(confirmationNumber, builderForwardVideoGenerationTimeout);

                // Initialize SignalR connection
                videoStatusHub.initialize()
                    .then(() => {
                        console.log('SignalR initialized for BuilderForward video status');
                    })
                    .catch((error) => {
                        console.error('SignalR initialization failed, videos will need manual refresh:', error);
                    });
            }

            if ($('#property_video').is('.pending')) {
                // Register property/custom video handler
                // NOTE: Builder products use 'custom' video type for Educational videos
                // (unlike ListNLock which uses 'property')
                videoStatusHub.registerVideoHandler(
                    'custom',
                    // On success
                    function(data) {
                        console.log('Property video SignalR notification received:', data);

                        // Validate data before updating UI
                        if (!data.videoUrl || !data.thumbnailUrl) {
                            console.warn('Property video data incomplete:', data);
                            $('#property_video_loading').addClass('d-none');
                            $('#instructions-div').removeClass('d-none');
                            $('#instructions-div p').text('Video is still processing. Please refresh the page.').addClass('upload-info');
                            return;
                        }

                        // Update UI directly from SignalR data - no AJAX call needed!
                        $('#property_video [data-role="thumbnail"]').attr('data-src', data.thumbnailUrl);
                        $('#property_video [data-role="play-button"]').attr('href', data.videoUrl);
                        $('#property_video').removeClass('pending');
                        $('#property_video_loading').addClass('d-none');

                        // Set download URL if provided
                        if (data.downloadUrl) {
                            $('[download="CustomVideo"]').prop('href', data.downloadUrl);
                            $('[download="CustomVideo"]').parent().removeClass('d-none');
                        }

                        new VideoPlayer();

                        // Set QR code URL if provided
                        if (data.qrCodeUrl) {
                            // FIX: qrCodeUrl is a download URL with fl_attachment flag
                            // For img src, we need the display URL (remove fl_attachment transformation)
                            var qrDisplayUrl = data.qrCodeUrl.replace(/\/fl_attachment:[^\/]+\//, '/');

                            $('#property_video_qr').attr('src', qrDisplayUrl);
                            $('#property_video_qr').removeClass('d-none');
                            $('#property_video_qr_loading').addClass('d-none');

                            // Download link uses the original qrCodeUrl (with fl_attachment)
                            $('[download="VideoQRCode"]').attr('href', data.qrCodeUrl);
                            $('[download="VideoQRCode"]').parent().removeClass('d-none');
                        }

                        $('#instructions-div').addClass('d-none');
                        console.log('Property video UI updated successfully from SignalR data');
                    },
                    // On timeout
                    function(videoType) {
                        $('#instructions-div p').text('Unable to generate customized video. Please try again.').addClass('upload-error');
                    },
                    // On error
                    function(error) {
                        console.error('Property video error:', error);
                        $('#instructions-div p').text('Unable to generate customized video. Please try again.').addClass('upload-error');
                    }
                );
            }

            if ($('#educational_video').is('.pending')) {
                // Register educational/social video handler
                videoStatusHub.registerVideoHandler(
                    'social',
                    // On success
                    function(data) {
                        console.log('Educational video SignalR notification received:', data);

                        // Validate data before updating UI
                        if (!data.videoUrl || !data.thumbnailUrl) {
                            console.warn('Educational video data incomplete:', data);
                            $('#educational_video_loading').addClass('d-none');
                            $('#instructions-edu-div').removeClass('d-none');
                            $('#instructions-edu-div p').text('Video is still processing. Please refresh the page.').addClass('upload-info');
                            return;
                        }

                        // Update UI directly from SignalR data - no AJAX call needed!
                        $('#educational_video [data-role="thumbnail"]').attr('data-src', data.thumbnailUrl);
                        $('#educational_video [data-role="play-button"]').attr('href', data.videoUrl);
                        $('#educational_video').removeClass('pending');
                        $('#educational_video_loading').addClass('d-none');

                        // Set download URL if provided
                        if (data.downloadUrl) {
                            $('[download="CustomVideo1"]').prop('href', data.downloadUrl);
                            $('[download="CustomVideo1"]').parent().removeClass('d-none');
                        }

                        new VideoPlayer();

                        $('#instructions-edu-div').addClass('d-none');
                        console.log('Educational video UI updated successfully from SignalR data');
                    },
                    // On timeout
                    function(videoType) {
                        $('#instructions-edu-div p').text('Unable to generate customized video. Please try again.').addClass('upload-error');
                    },
                    // On error
                    function(error) {
                        console.error('Educational video error:', error);
                        $('#instructions-edu-div p').text('Unable to generate customized video. Please try again.').addClass('upload-error');
                    }
                );
            }

            // Database polling fallback - kicks in if SignalR fails or notifications are missed
            var pollingInterval = null;

            function startPollingFallback() {
                if (pollingInterval) {
                    console.log('BFL: Polling fallback already running');
                    return;
                }

                console.log('BFL: Starting polling fallback for pending videos');
                var pollDelay = 10000; // Start at 10s
                var maxDelay = 60000;  // Max 60s between polls
                var maxRetries = 12;   // ~5 minutes total
                var retryCount = 0;
                var consecutiveErrors = 0;

                function poll() {
                    var hasPending = $('#property_video.pending, #educational_video.pending').length > 0;

                    if (!hasPending || retryCount >= maxRetries) {
                        if (!hasPending) console.log('BFL: No pending videos, stopping polling fallback');
                        else console.log('BFL: Max polling retries reached, stopping fallback');
                        pollingInterval = null;
                        return;
                    }

                    retryCount++;
                    console.log('BFL: Polling for video status updates (attempt ' + retryCount + '/' + maxRetries + ')');
                    $.ajax({
                        url: window.location.pathname + '/get-video-status',
                        type: 'GET',
                        data: { confirmationNumber: confirmationNumber },
                        timeout: 15000,
                        success: function(response) {
                            consecutiveErrors = 0;
                            pollDelay = 10000; // Reset delay on success
                            if (response) {
                                console.log('BFL: Polling received video status:', response);
                                updateVideosFromPolling(response);
                            }
                            pollingInterval = setTimeout(poll, pollDelay);
                        },
                        error: function(xhr, status, error) {
                            consecutiveErrors++;
                            console.warn('BFL: Polling failed (attempt ' + retryCount + ', consecutive errors: ' + consecutiveErrors + '):', error);
                            pollDelay = Math.min(pollDelay * 2, maxDelay);
                            pollingInterval = setTimeout(poll, pollDelay);
                        }
                    });
                }

                pollingInterval = setTimeout(poll, pollDelay);
            }

            function updateVideosFromPolling(response) {
                // Update property video if ready and still pending
                if (response.propertyVideo && $('#property_video').is('.pending')) {
                    console.log('BFL: Updating property video from polling');
                    var data = response.propertyVideo;

                    if (data.videoUrl && data.videoUrl.startsWith('ERROR:')) {
                        console.warn('BFL: Property video has error:', data.videoUrl);
                    } else if (data.thumbnailUrl && data.thumbnailUrl.startsWith('ERROR:')) {
                        console.warn('BFL: Property thumbnail has error:', data.thumbnailUrl);
                    } else {
                        $('#property_video [data-role="thumbnail"]').attr('data-src', data.thumbnailUrl);
                        $('#property_video [data-role="thumbnail"]').css('background-image', 'url("' + data.thumbnailUrl + '")');
                        $('#property_video [data-role="play-button"]').attr('href', data.videoUrl);
                        $('#property_video').removeClass('pending');
                        $('#property_video_loading').addClass('d-none');

                        if (data.downloadUrl) {
                            $('[download="CustomVideo"]').attr('href', data.downloadUrl);
                            $('[download="CustomVideo"]').parent().removeClass('d-none');
                        }

                        if (data.qrCodeUrl) {
                            var qrDisplayUrl = data.qrCodeUrl.replace(/\/fl_attachment:[^\/]+\//, '/');
                            $('#property_video_qr').attr('src', qrDisplayUrl);
                            $('#property_video_qr').removeClass('d-none');
                            $('#property_video_qr_loading').addClass('d-none');
                            $('[download="VideoQRCode"]').attr('href', data.qrCodeUrl);
                            $('[download="VideoQRCode"]').parent().removeClass('d-none');
                        }

                        $('#instructions-div').addClass('d-none');
                        new VideoPlayer();
                        console.log('BFL: Property video updated from polling');
                    }
                }

                // Update social/educational video if ready and still pending
                if (response.socialVideo && $('#educational_video').is('.pending')) {
                    console.log('BFL: Updating educational video from polling');
                    var data = response.socialVideo;

                    if (data.videoUrl && data.videoUrl.startsWith('ERROR:')) {
                        console.warn('BFL: Social video has error:', data.videoUrl);
                    } else if (data.thumbnailUrl && data.thumbnailUrl.startsWith('ERROR:')) {
                        console.warn('BFL: Social thumbnail has error:', data.thumbnailUrl);
                    } else {
                        $('#educational_video [data-role="thumbnail"]').attr('data-src', data.thumbnailUrl);
                        $('#educational_video [data-role="thumbnail"]').css('background-image', 'url("' + data.thumbnailUrl + '")');
                        $('#educational_video [data-role="play-button"]').attr('href', data.videoUrl);
                        $('#educational_video').removeClass('pending');
                        $('#educational_video_loading').addClass('d-none');

                        if (data.downloadUrl) {
                            $('[download="CustomVideo1"]').attr('href', data.downloadUrl);
                            $('[download="CustomVideo1"]').parent().removeClass('d-none');
                        }

                        $('#instructions-edu-div').addClass('d-none');
                        new VideoPlayer();
                        console.log('BFL: Educational video updated from polling');
                    }
                }
            }

            // Start polling: 30s grace period after SignalR init, or immediately if SignalR failed
            if ($('#property_video').is('.pending') || $('#educational_video').is('.pending')) {
                if (videoStatusHub) {
                    // Give SignalR 30 seconds to deliver notifications before falling back to polling
                    setTimeout(function() {
                        if ($('#property_video').is('.pending') || $('#educational_video').is('.pending')) {
                            console.log('BFL: SignalR grace period expired, starting polling fallback');
                            startPollingFallback();
                        }
                    }, 30000);
                } else {
                    // No SignalR connection, start polling immediately
                    startPollingFallback();
                }
            }

            // Clean up SignalR connection and polling when leaving page
            $(window).on('beforeunload', function() {
                if (videoStatusHub) {
                    videoStatusHub.stop();
                }
                if (pollingInterval) {
                    clearTimeout(pollingInterval);
                    pollingInterval = null;
                }
            });

            if ($('#reorder_signrider').length) {
                var script = document.createElement('script');
                script.type = 'text/javascript';
                script.src = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyAiTYeI5JpL0iYv5WskHudfIQwHKvZVK6E&libraries=places&callback=GinitMap2';
                script.async = true;
                document.body.appendChild(script);

                $('[data-toggle="tooltip"]').tooltip();

                $('#reorder_signrider').on('click', function () {
                    $('#signrider_reorder_dialog').addClass('show');
                });

                $('#signrider_newaddress').on('change', function () {
                    $('#signrider_address_form').toggleClass('active');
                    $('.pac-container').css('z-index', '10001');
                });

                $('#cancel_reorder').on('click', function () {
                    $('#address_form_error, #signrider_order_error').addClass('d-none');

                    $('#street_number').val('');
                    $('#route').val('');
                    $('#locality').val('');
                    $('#administrative_area_level_1').val('');
                    $('#postal_code').val('');

                    $('#signrider_reorder_dialog').removeClass('show');

                    $("#signrider_newaddress").prop("checked", false);
                    $('#signrider_address_form').removeClass('active');
                });

                $('#confirm_reorder').on('click', function () {
                    $('#signrider_order_error').addClass('d-none');

                    if ($('#signrider_newaddress').is(':checked')) {
                        var streetNumber = $('#street_number').val();
                        var streetName = $('#route').val();
                        var city = $('#locality').val();
                        var state = $('#administrative_area_level_1').val();
                        var zip = $('#postal_code').val();

                        if (!streetNumber.length || !streetName.length || !city.length || !state.length || !zip.length) {
                            $('#address_form_error').text('Please enter a valid shipping address').removeClass('d-none');
                            return;
                        }
                    }

                    $.post({
                        url: "reorder-yard-sign?confirmation=" + $('#hdnConfirmationNumber').val(),
                        data: { streetNumber, streetName, city, state, zip },
                        beforeSend: function () {
                            $('.dialog-content, .dialog-buttons').addClass('d-none');
                            $('.dialog-loading').removeClass('d-none');
                        }
                    })
                        .done(function () {
                            $('#success_message, #close_reorder').removeClass('d-none');
                            $('#cancel_reorder, #confirm_reorder').addClass('d-none');
                            $('.dialog-content').children().not('#success_message').addClass('d-none');
                        })
                        .fail(function () {
                            $('#address_error').removeClass('d-none');
                            $('#signrider_order_error').removeClass('d-none').children().first().text('Unable to place new sign rider order. Please try again.');
                        })
                        .always(function () {
                            $('.dialog-content, .dialog-buttons').removeClass('d-none');
                            $('.dialog-loading').addClass('d-none');
                        });
                });

                $('#autocomplete').bind("cut copy paste", function (e) {
                    e.preventDefault();
                });

                $('#close_reorder').on('click', function () {
                    $('#signrider_reorder_dialog').removeClass('show');
                    $('#reorder_signrider').parent().addClass('d-none');
                });
            }
        });
    }
});